import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import {
  FaLock,
  FaPiggyBank,
  FaGlobeAmericas,
  FaSyncAlt,
  FaChartBar,
  FaHeadset
} from 'react-icons/fa';
import COLORS from '../../../../../../constants/colors';

const CampaignFeatures = () => {
  const features = [
    {
      title: 'Secure Transactions',
      description:
        'End‑to‑end encryption and PCI‑DSS–compliant payment rails keep every contribution safe.',
      icon: <FaLock size={24} color={COLORS.primary} />
    },
    {
      title: 'Flexible Withdrawal',
      description:
        'Access your raised funds at any stage of the campaign without hidden fees.',
      icon: <FaPiggyBank size={24} color={COLORS.primary} />
    },
    {
      title: 'Global Donation Options',
      description:
        'Accept cards, mobile money, and international wallets so supporters can give from anywhere.',
      icon: <FaGlobeAmericas size={24} color={COLORS.primary} />
    },
    {
      title: 'Real‑Time Updates',
      description:
        'Donors receive instant notifications on milestones so they stay engaged and keep sharing.',
      icon: <FaSyncAlt size={24} color={COLORS.primary} />
    },
    {
      title: 'Transparent Reporting',
      description:
        'Built‑in analytics dashboards track inflows, outflows, and campaign impact in one view.',
      icon: <FaChartBar size={24} color={COLORS.primary} />
    },
    {
      title: '24 / 7 Human Support',
      description:
        'Our dedicated team is always on hand via chat, email, and phone to resolve any issues.',
      icon: <FaHeadset size={24} color={COLORS.primary} />
    }
  ];

  return (
    <Box sx={{ backgroundColor: COLORS.background, py: 8 }}>
      <Box
        sx={{
          maxWidth: 1200,
          margin: '0 auto',
          px: 3,
          textAlign: 'center'
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          color={COLORS.primary}
          mb={4}
        >
          Our Promise
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {features.map(({ title, description, icon }, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={idx}
              sx={{ display: 'flex' }}
            >
              <Card
                sx={{
                  flex: 1,
                  borderRadius: 5,
                  p: 4,
                  backgroundColor: COLORS.white,
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  boxShadow: `0 2px 10px ${COLORS.primary}15`,
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: `0 6px 20px ${COLORS.primary}30`
                  }
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    mb: 3,
                    borderRadius: '50%',
                    backgroundColor: `${COLORS.primary}10`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  {icon}
                </Box>

                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color={COLORS.primary}
                    mb={1}
                  >
                    {title}
                  </Typography>
                  <Typography variant="body2" color={COLORS.text}>
                    {description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CampaignFeatures;
